import { INTEGRATIONS } from "../../data/landingContent";
import IntegrationIcon from "./IntegrationIcon";
import Reveal from "./Reveal";

export default function Integrations() {
  return (
    <section id="integrations" className="integrations-section" aria-labelledby="integrations-heading">
      <div className="wrap">
        <Reveal>
          <span className="kicker">Integrations</span>
          <h2 className="section-title" id="integrations-heading">
            Your Google Drive. <b>WhatsApp follow-up.</b>
          </h2>
          <p className="section-lede">
            Sync patient files to your own Google Drive, send e-prescriptions on WhatsApp, and run
            automated appointment &amp; medicine reminders — all tied to the same EMR chart, not a
            separate tool.
          </p>
        </Reveal>

        <Reveal as="div" className="integrations-panel reveal-stagger">
          <div className="integrations-grid">
            {INTEGRATIONS.map((item) => (
              <article
                className={[
                  "integration-card",
                  item.accent ? "accent" : "",
                  item.featured ? "is-featured" : "",
                  item.agent ? "is-agent" : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
                key={item.name}
              >
                <div className="integration-card-top">
                  <span className="integration-icon" aria-hidden="true">
                    <IntegrationIcon logo={item.logo} fallback={item.icon} />
                  </span>
                  {item.agent && (
                    <span className="integration-badge integration-badge--agent">Agent</span>
                  )}
                  {item.featured && !item.agent && (
                    <span className="integration-badge integration-badge--core">Core</span>
                  )}
                </div>
                <h3>{item.name}</h3>
                <p>{item.desc}</p>
              </article>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
